import { Link, type ErrorComponentProps } from '@tanstack/react-router';
import { SearchX, TriangleAlert } from 'lucide-react';
import { errorMessage, requestIdOf } from '../api/errors';
import { useI18n } from '../i18n/I18nProvider';
import { Button } from '../ui/Button';
import { EmptyState } from '../ui/Feedback';
import { Code, Page, Panel, useDocumentTitle } from '../ui/Layout';

export function NotFoundPage() {
  const { t } = useI18n();
  useDocumentTitle(t.errors.notFoundTitle);
  return (
    <Page narrow>
      <Panel>
        <EmptyState
          icon={<SearchX size={22} />}
          title={t.errors.notFoundTitle}
          action={<Link to="/">{t.errors.goHome}</Link>}
        >
          {t.errors.notFoundBody}
        </EmptyState>
      </Panel>
    </Page>
  );
}

/** Shown when an organization does not exist or the user is not a member (the API answers 404). */
export function OrgNotFoundPage() {
  const { t } = useI18n();
  useDocumentTitle(t.errors.orgNotFoundTitle);
  return (
    <Page narrow>
      <Panel>
        <EmptyState
          icon={<SearchX size={22} />}
          title={t.errors.orgNotFoundTitle}
          action={<Link to="/orgs">{t.shell.allOrganizations}</Link>}
        >
          {t.errors.orgNotFoundBody}
        </EmptyState>
      </Panel>
    </Page>
  );
}

export function RouteErrorPage({ error, reset }: ErrorComponentProps) {
  const { t } = useI18n();
  const requestId = requestIdOf(error);
  return (
    <Page narrow>
      <Panel>
        <EmptyState
          icon={<TriangleAlert size={22} />}
          title={errorMessage(t, error)}
          action={
            <Button variant="primary" onPress={reset}>
              {t.common.retry}
            </Button>
          }
        >
          {requestId ? (
            <>
              {t.errors.reference}: <Code>{requestId}</Code>
            </>
          ) : null}
        </EmptyState>
      </Panel>
    </Page>
  );
}
